module.exports = __webpack_public_path__ + "img/productbg2.f4c0ed6a.png";